<template>
  <div class="timeSlider">
    <div class="ui" v-if="showUI">
      <a href="#" @click="resetValue">reset</a>
    </div>
    <VueSlider
      class="slider"
      :min="minYear"
      :max="maxYear"
      :processDragable="true"
      v-model="value"
    >
    </VueSlider>
  </div>
</template>

<script>
import { Filter } from '../lib/Filter'
import VueSlider from 'vue-slider-component'

export default {
  name: "TimeSlider",
  components: {
    VueSlider
  },
  computed: {
    maxYear: function() {
      return this.extent[1].getFullYear()
    },
    minYear: function() {
      return this.extent[0].getFullYear()
    },
    showUI: function() {
      return this.value[0] != this.minYear || this.value[1] != this.maxYear
    },
    value: {
        get: function() {
          if (this.lowerFilter.value && this.upperFilter.value) {
            return [this.lowerFilter.value.getFullYear(), this.upperFilter.value.getFullYear()]
          } else {
            return [0, 2000]
          }
        },
        set: function(range) {
          this.lowerFilter.value = new Date(range[0], 0, 1)
          this.upperFilter.value = new Date(range[1], 11, 31)
        }
    }
  },
  methods: {
    resetValue: function() {
      this.value = [this.minYear, this.maxYear]
    }
  },
  props: {
    extent: Array,
    lowerFilter: Filter,
    upperFilter: Filter
  }
}
</script>

<style lang="less" scoped>
  .ui {
    text-align: right;
  }
</style>
